<template>
  <div id="join-jci-member">
    <v-card class="join-card" elevation="0" rounded="lg">
      <!-- Header Section -->
      <v-card class="header-card mb-8 overflow-hidden">
        <v-row align="center" class="fill-height pa-6">
          <v-col sm="7" xs="12" class="header-content d-flex align-center">
            <div class="header-icon-box">
              <v-icon size="48" color="white">mdi-account-check</v-icon>
            </div>
            <div class="header-text-content">
              <h1 class="header-title">{{ pageTitle }}</h1>
              <p class="header-subtitle">
                Connect prospective members with JCI membership
              </p>
            </div>
          </v-col>
          <v-col sm="5" xs="12" class="d-flex justify-end align-center gap-2">
            <v-btn @click="closePrompt" icon rounded class="action-btn" x-large>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- Form Section -->
      <v-container fluid class="px-6 px-md-8">
        <!-- Instructions Card -->
        <v-card class="instructions-card mb-8" elevation="0">
          <div class="instruction-heading">
            <v-icon class="mr-3">mdi-information-outline</v-icon>
            How It Works
          </div>
          <div class="instruction-content">
            <div class="requirement-box mb-4">
              <v-icon class="mr-3">mdi-check-circle</v-icon>
              <span>Select an existing JCI member from the list</span>
            </div>
            <div class="requirement-box">
              <v-icon class="mr-3">mdi-check-circle</v-icon>
              <span
                >Link them with the prospective member to complete the
                onboarding</span
              >
            </div>
          </div>
        </v-card>

        <!-- Form Card -->
        <v-card class="form-card mb-8" elevation="0">
          <v-form ref="form1" v-model="valid1" lazy-validation>
            <!-- Member Selection Section -->
            <div class="form-section">
              <h3 class="section-title mb-6">
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Select JCI Member
              </h3>

              <v-row>
                <v-col cols="12" sm="12" md="8">
                  <div class="form-field">
                    <label class="field-label required-field"
                      >Membership ID</label
                    >
                    <v-text-field
                      v-model="MembershipIdInput"
                      @keyup.enter="searchMember"
                      :rules="MemberIdRules"
                      :loading="MemberSearchLoading"
                      outlined
                      dense
                      clearable
                      prepend-icon="mdi-magnify"
                      append-icon="mdi-magnify-plus-outline"
                      @click:append="searchMember"
                      placeholder="Enter membership ID and press Enter"
                      class="member-search-field"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Validation Notes Section -->
            <div class="form-section mt-8" v-if="MemberFoundFlag">
              <h3 class="section-title mb-6">
                <v-icon class="mr-2">mdi-information-outline</v-icon>
                Validation Notes
              </h3>
              <v-row>
                <v-col cols="12">
                  <v-card class="validation-notes-card" elevation="0">
                    <div class="note-item">
                      <v-icon class="note-icon"
                        >mdi-check-circle-outline</v-icon
                      >
                      <span class="note-text"
                        >Member must be a JCI member </span
                      >
                    </div>
                    <div class="note-item">
                      <v-icon class="note-icon"
                        >mdi-check-circle-outline</v-icon
                      >
                      <span class="note-text"
                        >Member must have joined JCI before 1st March of current
                        year</span
                      >
                    </div>
                    <div class="note-item">
                      <v-icon class="note-icon"
                        >mdi-check-circle-outline</v-icon
                      >
                      <span class="note-text">
                        If the selected member belongs to a different LOM, that
                        LO must be chartered in the current year.
                      </span>
                    </div>
                    <div class="note-item">
                      <v-icon class="note-icon"
                        >mdi-check-circle-outline</v-icon
                      >
                      <span class="note-text">
                        Member must not already be linked to Mission One Lakh
                        for this year
                      </span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- Member Details Section -->
            <div class="form-section mt-8" v-if="MemberId > 0">
              <h3 class="section-title mb-6">
                <v-icon class="mr-2">mdi-card-account-details</v-icon>
                Member Details
              </h3>

              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <div class="member-photo-box">
                    <img
                      :src="member.MemberImage"
                      alt="Member Photo"
                      class="member-photo"
                      width="150"
                      height="150"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <label class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-account</v-icon
                      >
                      Member Name
                    </label>
                    <p class="detail-value">{{ member.Fullname }}</p>
                  </div>
                  <div class="detail-item mt-4">
                    <label class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-card-text</v-icon
                      >
                      Membership ID
                    </label>
                    <p class="detail-value">{{ member.MembershipId }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <label class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-phone</v-icon
                      >
                      Zone Name
                    </label>
                    <p class="detail-value">{{ member.ZoneName }}</p>
                  </div>
                  <div class="detail-item mt-4">
                    <label class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-email</v-icon
                      >
                      Email Address
                    </label>
                    <p class="detail-value">{{ member.EmailId }}</p>
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="detail-item">
                    <label class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-home</v-icon
                      >
                      Address
                    </label>
                    <p class="detail-value">{{ member.Address }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card>

        <!-- Action Buttons -->
        <div class="action-section mb-6">
          <v-row justify="end" class="gap-3">
            <v-col cols="auto">
              <v-btn
                @click.prevent="closePrompt"
                rounded
                outlined
                class="action-cancel-btn"
                min-width="150"
              >
                <v-icon left>mdi-close</v-icon>
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                :disabled="!valid1 || !MemberFoundFlag"
                @click.prevent="confirmAlert"
                :loading="SubmitFlag"
                rounded
                class="action-save-btn"
                min-width="150"
                color="white"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Link Member
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>
  </div>
</template>
      
      <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
    recordData: {
      type: Array,
      required: true,
    },
    LomCode: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      menu1: false,
      MembershipId: "",
      MembershipIdInput: "",
      ResultFlag: false,
      MembershipIdRules: [(v) => !!v || "Membership ID is required"],
      rows: [],
      member: {},
      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberSearchLoading: false,
      MemberIdOptions: [],
      MemberId: "",
      MemberFoundFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;
      }
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberId: function () {
      console.log("watch MemberId");
      this.getMemberDetails();
    },
    MembershipIdInput: function () {
      console.log("watch MembershipIdInput");
      this.member = {};
      this.MemberId = "";
      this.MemberFoundFlag = false;
    },
  },
  created() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "mol_phase4",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
    },
    closePrompt() {
      console.log("closePrompt called");
      console.log(this.ResultFlag);
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    searchMember() {
      console.log("searchMember called");
      if (!this.MembershipIdInput) {
        this.toast("error", "Please enter membership ID");
        return;
      }

      this.MemberSearchLoading = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var search_url = server_url + "api/members/search";
      var upload = {
        UserInterface: 13,
        MembershipId: this.MembershipIdInput,
        JoinJciMemberFlag: true,
        LomCode: this.LomCode,
      };
      console.log("upload=" + JSON.stringify(upload));

      const thisIns = this;
      var output = "";
      var flag = 0;

      this.$http({
        url: search_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.MemberSearchLoading = false;

          output = response.data.output;
          flag = response.data.flag;
          var records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.member = records;
            thisIns.MemberId = records.MemberId;
            thisIns.MemberFoundFlag = true;
            thisIns.toast("success", output);
          } else {
            thisIns.member = {};
            thisIns.MemberId = "";
            thisIns.MemberFoundFlag = false;
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.MemberSearchLoading = false;
          thisIns.toast("error", "Error searching member");
        });
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      if (temp_code && this.member && Object.keys(this.member).length > 0) {
        console.log("member=" + JSON.stringify(this.member));
        this.AllMembers = [
          {
            YearwiseOfficesHeldId: null,
            MemberId: this.member.MemberId,
            MemberName: this.member.Fullname,
            DesignationId: "",
            Designation: "",
          },
        ];
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields");
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      //   validate1 = false;

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/mission-onelakh/mol-member-update";
        var upload = {
          UserInterface: 8,
          Member: [this.recordData.MolMemberId],
          MembershipId: this.member.MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.resetForm();
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
              this.toast("success", output);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        thisIns.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Color Palette - JCI Brand Colors
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$success-green: #4caf50;
$error-red: #f44336;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

#join-jci-member {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  .join-card {
    border-radius: 20px !important;
    background: #ffffff !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .header-card {
    background: linear-gradient(
      135deg,
      $navy 0%,
      $aqua 50%,
      $navy 100%
    ) !important;
    border-radius: 20px !important;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 40px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 70%
      );
      animation: shimmer 3s infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }
  }

  .header-icon-box {
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.25) 0%,
      rgba(255, 255, 255, 0.15) 100%
    );
    backdrop-filter: blur(15px);
    border-radius: 16px;
    padding: 16px;
    width: fit-content;
    flex-shrink: 0;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    margin-right: 20px;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    }
  }

  .header-text-content {
    flex: 1;
    min-width: 0;
  }

  .header-title {
    font-size: 32px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideInLeft 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
    padding: 0;
    line-height: 1.2;
  }

  .header-subtitle {
    font-size: 15px;
    opacity: 0.95;
    animation: slideInLeft 1s ease-out 0.1s backwards;
    letter-spacing: 0.3px;
    color: rgba($text-white, 0.9);
    font-weight: 500;
    margin: 6px 0 0 0;
    line-height: 1.4;
  }

  .action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    color: white !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

    &:hover {
      transform: translateY(-6px);
      background: rgba(255, 255, 255, 0.25) !important;
      border-color: rgba(255, 255, 255, 0.5) !important;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
    }
  }

  .instructions-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #fff5e6 0%, #fffaf0 100%) !important;
    box-shadow: 0 12px 32px rgba(237, 190, 56, 0.15) !important;
    border: 2px solid rgba(237, 190, 56, 0.25) !important;
    padding: 24px !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s backwards;

    .instruction-heading {
      font-size: 16px;
      font-weight: 800;
      color: $navy;
      display: flex;
      align-items: center;
      margin: 0 0 16px 0;
      text-transform: uppercase;
      letter-spacing: 0.6px;

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover .v-icon {
        transform: rotate(20deg) scale(1.15);
      }
    }

    .instruction-content {
      .requirement-box {
        display: flex;
        gap: 16px;
        background: linear-gradient(
          135deg,
          rgba(76, 175, 80, 0.12),
          rgba(76, 175, 80, 0.08)
        );
        border-left: 5px solid $success-green;
        padding: 16px 14px;
        border-radius: 12px;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(
            135deg,
            rgba(76, 175, 80, 0.15),
            rgba(76, 175, 80, 0.1)
          );
          box-shadow: 0 6px 16px rgba(76, 175, 80, 0.15);
          transform: translateY(-2px);
        }

        .v-icon {
          flex-shrink: 0;
          transition: all 0.3s ease;
        }
        &:hover .v-icon {
          transform: scale(1.2);
        }

        span {
          color: $text-off-black;
          font-weight: 600;
          font-size: 14px;
          line-height: 1.6;
        }
      }
    }
  }

  .form-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
    box-shadow: 0 16px 48px rgba(58, 103, 177, 0.12) !important;
    border: 2px solid rgba(0, 151, 215, 0.1) !important;
    padding: 24px !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s backwards;

    .form-section {
      .section-title {
        font-size: 18px;
        font-weight: 800;
        color: $navy;
        display: flex;
        align-items: center;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        padding-bottom: 12px;
        border-bottom: 3px solid $aqua;

        .v-icon {
          transition: all 0.3s ease;
        }
        &:hover .v-icon {
          transform: rotate(-10deg) scale(1.15);
        }
      }

      .form-field {
        margin-bottom: 8px;

        .field-label {
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: $navy;
          display: block;
          margin-bottom: 8px;

          &.required-field::after {
            content: "*";
            color: $error-red;
            margin-left: 4px;
          }
        }

        .member-autocomplete {
          &::v-deep {
            .v-input__prepend-inner {
              margin-right: 8px !important;
              .v-icon {
                color: $aqua;
              }
            }

            fieldset {
              border-color: rgba(0, 151, 215, 0.2) !important;
            }

            &.v-input--is-focused {
              fieldset {
                border-color: $aqua !important;
              }
              .v-icon {
                color: $navy;
              }
            }
          }
        }

        .detail-item {
          background: rgba(0, 151, 215, 0.05);
          border: 1px solid rgba(0, 151, 215, 0.1);
          border-radius: 8px;
          padding: 12px 14px;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(0, 151, 215, 0.08);
            border-color: rgba(0, 151, 215, 0.2);
            box-shadow: 0 4px 12px rgba(0, 151, 215, 0.1);
          }

          .detail-label {
            font-size: 11px;
            font-weight: 800;
            color: #888;
            text-transform: uppercase;
            letter-spacing: 0.6px;
            display: flex;
            align-items: center;
            margin: 0 0 6px 0;
          }

          .detail-value {
            font-size: 15px;
            font-weight: 700;
            color: $navy;
            margin: 0;
            letter-spacing: 0.2px;
          }
        }
      }
    }
  }

  .validation-notes-card {
    background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%) !important;
    border: 2px solid #81c784 !important;
    border-radius: 12px !important;
    padding: 20px !important;
    box-shadow: 0 4px 16px rgba(76, 175, 80, 0.15) !important;

    .note-item {
      display: flex;
      gap: 16px;
      align-items: flex-start;
      margin-bottom: 14px;
      padding: 12px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 8px;
      border-left: 4px solid #4caf50;
      transition: all 0.3s ease;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.9);
        transform: translateX(4px);
        box-shadow: 0 2px 8px rgba(76, 175, 80, 0.1);
      }

      .note-icon {
        color: #4caf50;
        font-size: 20px !important;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .note-text {
        color: #1b5e20;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }

  .action-section {
    padding: 20px 0;
    border-top: 2px solid #f0f0f0;
    margin-top: 20px;

    .gap-3 {
      gap: 16px;
    }

    .action-cancel-btn {
      font-weight: 700 !important;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: #666 !important;
      border-color: #ddd !important;
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

      &:hover {
        border-color: $aqua !important;
        color: $aqua !important;
        transform: translateY(-4px);
        box-shadow: 0 8px 20px rgba(0, 151, 215, 0.2) !important;
      }

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover .v-icon {
        transform: scale(1.15);
      }
    }

    .action-save-btn {
      background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
      font-weight: 700 !important;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 12px 32px rgba(0, 151, 215, 0.3) !important;
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

      &:hover:not(:disabled) {
        transform: translateY(-6px);
        box-shadow: 0 16px 48px rgba(0, 151, 215, 0.4) !important;
      }

      &:disabled {
        background: linear-gradient(135deg, #ccc 0%, #aaa 100%) !important;
        box-shadow: none !important;
      }

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover:not(:disabled) .v-icon {
        transform: scale(1.2);
      }
    }
  }

  @media (max-width: 960px) {
    padding: 20px 12px;

    .header-card {
      border-radius: 16px;
    }
    .header-title {
      font-size: 26px;
    }
    .header-subtitle {
      font-size: 14px;
    }
    .section-title {
      font-size: 16px;
    }
    .form-card,
    .instructions-card {
      border-radius: 14px;
    }

    .action-section {
      .v-row > * {
        margin: 8px 0;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 16px 10px;

    .header-card {
      border-radius: 14px;
    }
    .header-title {
      font-size: 20px;
    }
    .header-subtitle {
      font-size: 12px;
    }
    .section-title {
      font-size: 14px;
    }
    .form-card,
    .instructions-card {
      border-radius: 12px;
      padding: 16px !important;
    }

    .action-section {
      flex-direction: column;

      .action-cancel-btn,
      .action-save-btn {
        width: 100% !important;
        min-width: unset !important;
      }

      .v-row > * {
        margin: 6px 0;
      }
    }
  }
}
</style>
    